import React from "react";
import moment from "moment";
export default class MyRegularWS_List extends React.Component {
  getSerSend = attendee => {
    if (attendee.cert_sended) {
      return `Yes (${moment(attendee.cert_sended_at).format("DD.MM.YYYY")})`;
    } else {
      return "No";
    }
  };
  renderListElement = attendee => {
    const name = [attendee.first_name, attendee.last_name].join(" ");
    const certSend = this.getSerSend(attendee);

    return (
      <li
        className="attendee-list-row attendee-row"
        key={`attendee_${attendee.id}`}
      >
        <div className="al-cell-checkbox">
          <div className="checkbox">
            <input
              type="checkbox"
              id={`select-att-${attendee.id}`}
              name="General Public"
              checked={this.props.selected.indexOf(attendee.id) != -1}
              onChange={() => this.props.selectedCheckbox(attendee.id)}
            />
            <label
              htmlFor={`select-att-${attendee.id}`}
              title="select_attendee"
            />
          </div>
        </div>
        <div className="al-cell-name">{name}</div>
        <div className="al-cell-email">{attendee.email}</div>
        <div className="al-cell-certstatus">{certSend}</div>
        <div className="al-cell-edit">
          <button
            className="btn-edit-attendee"
            onClick={() => this.props.onEdit(attendee)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18px"
              height="18px"
              viewBox="0 0 528.899 528.899"
            >
              <path d="M328.883 89.125l107.59 107.589-272.34 272.34L56.604 361.465l272.279-272.34zm189.23-25.948l-47.981-47.981c-18.543-18.543-48.653-18.543-67.259 0l-45.961 45.961 107.59 107.59 53.611-53.611c14.382-14.383 14.382-37.577 0-51.959zM.3 512.69c-1.958 8.812 5.998 16.708 14.811 14.565l119.891-29.069L27.473 390.597.3 512.69z" />
            </svg>
          </button>
          <button
            className="btn-close-attendee"
            onClick={() => this.props.onDelete(attendee.id)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18">
              <path d="M14 1h-3.5L9.499 0h-5l-1 1h-3.5v2H14M.999 16A2 2 0 0 0 3 18h8a2 2 0 0 0 2-2V4H.999v12z" />
            </svg>
          </button>
        </div>
      </li>
    );
  };

  render() {
    const { workshop } = this.props;
    const attendees = workshop.attendees;
    const user = localStorage.getItem("user");
    const currentUser = JSON.parse(user);

    return (
      <div className="col-12 col-md-9 my-regular-list">
        <div className="attendee-list-container">
          <ul className="attendee-list">
            <li className="attendee-list-row header">
              <div className="al-cell-checkbox" />
              <div className="al-cell-name">Name</div>
              <div className="al-cell-email">E-mail</div>
              <div className="al-cell-certstatus">Cert Sent</div>
              <div className="al-cell-edit" />
            </li>
            {(attendees || []).map(attendee =>
              this.renderListElement(attendee)
            )}
          </ul>

          <span
            className="btn-select-all"
            onClick={() => this.props.selectAll()}
          >
            Select / Deselect all
          </span>

          <button
            className="btn-prime-blue"
            onClick={() => this.props.sendSertificate()}
          >
            Email Certs To Selected Attendees
          </button>

          <div className="template-btn-wrapper">
            <button
              className="btn-show-email"
              onClick={() => this.props.showEmailTemplate()}
            >
              View Email Template
            </button>
            <button
              className="btn-show-cert"
              onClick={() => this.props.showCertTemplate()}
            >
              View CPD Cert Template
            </button>
          </div>
          {currentUser.role === 'admin' ? (
              <ol className="attendee-list">
                {workshop.transactions && workshop.transactions.length > 0 ? <p>{`${workshop.transactions.length} successful access code entries in total:`}</p> : null}
                {(workshop.transactions || []).map(transaction => (
                  <li className="attendee-list-row attendee-row">
                    <div className="al-cell-name">{transaction}</div>
                  </li>
                ))}
              </ol>
            ) : null
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/myRegularWorkshop/MyRegularWS_List.jsx